import BaseService from "core/api/BaseService";
import { API_ENDPOINTS } from "utils/constants";

class ChatService extends BaseService {
  constructor() {
    super("/chat");
  }

  async getConversations() {
    return this.get("conversations");
  }

  async createOrGetConversation(participantId) {
    return this.post("conversations", { participantId });
  }

  async getMessages(conversationId) {
    return this.get(`conversations/${conversationId}/messages`);
  }

  async sendMessage(conversationId, text) {
    return this.post("messages", { conversationId, text });
  }
}

export default new ChatService();
